// AlertRBDBanner.jsx
import * as React from "react";
import { Box, Typography, Link, Paper, Divider } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate } from "react-router-dom";

export default function AlertRBDBanner({
  rbd,
  estado,
  direccion = "-",
}) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    navigate(`/establecimiento_modificar/${rbd}`);
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  };

  const isRechazado = estado === "No Verificado";

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        overflow: "hidden",
        border: "1px solid #FFAB91",
        width: "100%",
      }}
    >
      {/* Barra superior */}
      <Box
        sx={{
          backgroundColor: "#FFB39D",
          py: 1.2,
          px: 2,
          textAlign: "center",
          fontWeight: 400,
          fontSize: "1.05rem",
        }}
      >
        ¡Atención! representante RBD {rbd}
      </Box>

      <Divider sx={{ borderColor: "white" }} />

      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          p: 2,
          backgroundColor: "#FFAB91",
        }}
      >
        <Box
          sx={{
            border: "2px solid #FFAB91",
            borderRadius: "50%",
            p: "6px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <InfoOutlinedIcon color="error" sx={{ fontSize: 48 }} />
        </Box>

        <Box>
          <Typography
            variant="h3"
            sx={{ fontWeight: 700, mb: 0.5, lineHeight: 1.2 }}
          >
            {isRechazado
              ? "Verificación de dirección rechazada"
              : "Verificación de dirección del establecimiento y confirmación de la conexión de servicio de internet"}
          </Typography>

          <Typography variant="body2" sx={{ py: 1 }}>
            {isRechazado ? (
              <>
                MINEDUC ha rechazado la dirección ‘{direccion}’, le sugerimos
                volver a llenar el datos para la efectiva verificación de la
                dirección del establecimiento, por favor ingrese a{" "}
                <Link
                  component="button"
                  onClick={handleClick}
                  color="error"
                  sx={{
                    fontWeight: 700,
                    textDecoration: "underline",
                    textUnderlineOffset: "2px",
                  }}
                >
                  Editar datos del establecimiento
                </Link>{" "}
                para completar el proceso.
              </>
            ) : (
              <>
                Usted tiene pendiente <b>verificar</b> la dirección de su
                establecimiento y <b>confirmar</b> si cuenta con conexión de
                servicio de internet, por favor ingrese a{" "}
                <Link
                  component="button"
                  onClick={handleClick}
                  color="error"
                  sx={{
                    fontWeight: 700,
                    textDecoration: "underline",
                    textUnderlineOffset: "2px",
                  }}
                >
                  Editar datos del establecimiento
                </Link>{" "}
                y complete el proceso.
              </>
            )}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}